import { AnimatePresence } from "framer-motion";
import { memo } from "react";
import { Star, StarsContainer } from "./stars.style";
const Stars = () => {
    // const [check, setCheck] = useState(false)
    // useEffect(() => {
    //     let Timeout = setTimeout(() => setCheck(true), 100)
    //     return () => clearTimeout(Timeout)
    // }, [])
    const randomMove = () => Math.random() * 2
    const randomOpacity = () => Math.random()
    const random = () => Math.random()
    return (
        <>
            <StarsContainer >
                <AnimatePresence>
                    {[...Array(140)].map((_, i) => (
                        <Star
                            key={`star-${i}`}
                            initial={{
                                top: `calc(${random() * 100}% + ${randomMove()}px)`,
                                left: `calc(${random() * 100}% + ${randomMove()}px)`
                            }}
                            animate={{
                                top: `calc(${random() * 100}% + ${randomMove()}px)`,
                                left: `calc(${random() * 100}% + ${randomMove()}px)`,
                                opacity: randomOpacity(),
                                scale: [1, 1.2, 0],
                            }}
                            transition={{
                                duration: random() * 10 + 20,
                                repeat: Infinity,
                                ease: "linear",
                            }}
                            top={`${random() * 100}%`}
                            left={`${random() * 100}%`}
                            className="inline-block"
                        ></Star>
                    ))}
                </AnimatePresence>
            </StarsContainer>

        </>

    );
};

const MemoizedStars = memo(Stars);

export default MemoizedStars;